import { lazyWithPreload as lazy } from './lazyWithPreload'

/** DO NOT modify, contents are automatically generated (see cli-helper) */
export const Icons = {
  CustomAddBet: lazy(() => import('./Custom/add-bet')),
  CustomBetLoopLogo: lazy(() => import('./Custom/bet-loop-logo')),
  CustomBetSlipWithTabtouchLogo: lazy(() => import('./Custom/bet-slip-with-tabtouch-logo')),
  CustomBetslip: lazy(() => import('./Custom/betslip')),
  CustomCashOut: lazy(() => import('./Custom/cash-out')),
  CustomCashedOut: lazy(() => import('./Custom/cashed-out')),
  CustomEarlyPayout: lazy(() => import('./Custom/early-payout')),
  CustomEllipse12: lazy(() => import('./Custom/ellipse-12')),
  CustomSGM: lazy(() => import('./Custom/SGM')),
  CustomScale02: lazy(() => import('./Custom/scale-02')),
  CustomScanMyBet: lazy(() => import('./Custom/scan-my-bet')),
  CustomSpecialsStar: lazy(() => import('./Custom/specials-star')),
  CustomVisibilityOff: lazy(() => import('./Custom/visibility-off')),
  CustomVisibilityOn: lazy(() => import('./Custom/visibility-on')),
  DuocolorAlertCircle: lazy(() => import('./Figma/Duocolor/Alerts/alert-circle')),
  DuocolorAlertSquare: lazy(() => import('./Figma/Duocolor/Alerts/alert-square')),
  DuocolorAlertTriangle: lazy(() => import('./Figma/Duocolor/Alerts/alert-triangle')),
  DuocolorArrowCircleRight: lazy(() => import('./Figma/Duocolor/Arrows/arrow-circle-right')),
  DuocolorArrowNarrowRight: lazy(() => import('./Figma/Duocolor/Arrows/arrow-narrow-right')),
  DuocolorArrowsUp: lazy(() => import('./Figma/Duocolor/Arrows/arrows-up')),
  DuocolorAward03: lazy(() => import('./Figma/Duocolor/Education/award-03')),
  DuocolorBank: lazy(() => import('./Figma/Duocolor/Finance/bank')),
  DuocolorCalendar: lazy(() => import('./Figma/Duocolor/Time/calendar')),
  DuocolorCertificate02: lazy(() => import('./Figma/Duocolor/Education/certificate-02')),
  DuocolorCheckCircle: lazy(() => import('./Figma/Duocolor/General/check-circle')),
  DuocolorClock: lazy(() => import('./Figma/Duocolor/Time/clock')),
  DuocolorCloud01: lazy(() => import('./Figma/Duocolor/Weather/cloud-01')),
  DuocolorCloudRaining05: lazy(() => import('./Figma/Duocolor/Weather/cloud-raining-05')),
  DuocolorCloudSun02: lazy(() => import('./Figma/Duocolor/Weather/cloud-sun-02')),
  DuocolorCopy02: lazy(() => import('./Figma/Duocolor/General/copy-02')),
  DuocolorCreditCard02: lazy(() => import('./Figma/Duocolor/Finance/credit-card-02')),
  DuocolorCurrencyDollarCircle: lazy(() => import('./Figma/Duocolor/Finance/currency-dollar-circle')),
  DuocolorDelete: lazy(() => import('./Figma/Duocolor/Editor/delete')),
  DuocolorDice6: lazy(() => import('./Figma/Duocolor/Shapes/dice-6')),
  DuocolorDotsHorizontal: lazy(() => import('./Figma/Duocolor/General/dots-horizontal')),
  DuocolorFilterFunnel01: lazy(() => import('./Figma/Duocolor/General/filter-funnel-01')),
  DuocolorInfoCircle: lazy(() => import('./Figma/Duocolor/General/info-circle')),
  DuocolorLineChartUp01: lazy(() => import('./Figma/Duocolor/Line/line-chart-up-01')),
  DuocolorLoading01: lazy(() => import('./Figma/Duocolor/General/loading-01')),
  DuocolorLogOut02: lazy(() => import('./Figma/Duocolor/General/log-out-02')),
  DuocolorMarkerPin04: lazy(() => import('./Figma/Duocolor/Maps/marker-pin-04')),
  DuocolorPassport: lazy(() => import('./Figma/Duocolor/Maps/passport')),
  DuocolorPlus: lazy(() => import('./Figma/Duocolor/General/plus')),
  DuocolorSearchSm: lazy(() => import('./Figma/Duocolor/General/search-sm')),
  DuocolorShieldTick: lazy(() => import('./Figma/Duocolor/Security/shield-tick')),
  DuocolorStar01: lazy(() => import('./Figma/Duocolor/Shapes/star-01')),
  DuocolorSun: lazy(() => import('./Figma/Duocolor/Weather/sun')),
  DuocolorTrophy01: lazy(() => import('./Figma/Duocolor/Education/trophy-01')),
  DuocolorUsers02: lazy(() => import('./Figma/Duocolor/Users/users-02')),
  DuocolorUsersX: lazy(() => import('./Figma/Duocolor/Users/users-x')),
  DuocolorXCircle: lazy(() => import('./Figma/Duocolor/General/x-circle')),
  LineAlertCircle: lazy(() => import('./Figma/Line/Alerts/alert-circle')),
  LineAlertTriangle: lazy(() => import('./Figma/Line/Alerts/alert-triangle')),
  LineAnnotationAlert: lazy(() => import('./Figma/Line/Communication/annotation-alert')),
  LineArrowUp: lazy(() => import('./Figma/Line/Arrows/arrow-up')),
  LineBank: lazy(() => import('./Figma/Line/Finance/bank')),
  LineBankNote03: lazy(() => import('./Figma/Line/Finance/bank-note-03')),
  LineBell01: lazy(() => import('./Figma/Line/Alerts/bell-01')),
  LineBellPlus: lazy(() => import('./Figma/Line/Alerts/bell-plus')),
  LineBookmarkAdd: lazy(() => import('./Figma/Line/General/bookmark-add')),
  LineCheck: lazy(() => import('./Figma/Line/General/check')),
  LineCheckCircle: lazy(() => import('./Figma/Line/General/check-circle')),
  LineCheckCircleBroken: lazy(() => import('./Figma/Line/General/check-circle-broken')),
  LineCreditCard02: lazy(() => import('./Figma/Line/Finance/credit-card-02')),
  LineCurrencyDollarCircle: lazy(() => import('./Figma/Line/Finance/currency-dollar-circle')),
  LineEye: lazy(() => import('./Figma/Line/General/eye')),
  LineEyeOff: lazy(() => import('./Figma/Line/General/eye-off')),
  LineFaceId: lazy(() => import('./Figma/Line/Security/face-id')),
  LineGift01: lazy(() => import('./Figma/Line/Finance/gift-01')),
  LineHelpCircle: lazy(() => import('./Figma/Line/General/help-circle')),
  LineInfoCircle: lazy(() => import('./Figma/Line/General/info-circle')),
  LineLaptop02: lazy(() => import('./Figma/Line/Communication/laptop-02')),
  LineMail02: lazy(() => import('./Figma/Line/Communication/mail-02')),
  LineMaximize01: lazy(() => import('./Figma/Line/Layout/maximize-01')),
  LineMaximize02: lazy(() => import('./Figma/Line/Layout/maximize-02')),
  LineMenu01: lazy(() => import('./Figma/Line/General/menu-01')),
  LineMessageDotsSquare: lazy(() => import('./Figma/Line/Communication/message-dots-square')),
  LineMessageTextSquare02: lazy(() => import('./Figma/Line/Communication/message-text-square-02')),
  LineMinimize02: lazy(() => import('./Figma/Line/Layout/minimize-02')),
  LineNotificationBox: lazy(() => import('./Figma/Line/Alerts/notification-box')),
  LinePasscodeLock: lazy(() => import('./Figma/Line/General/passcode-lock')),
  LinePencil01: lazy(() => import('./Figma/Line/Editor/pencil-01')),
  LinePhone01: lazy(() => import('./Figma/Line/Communication/phone-01')),
  LinePhoneCall01: lazy(() => import('./Figma/Line/Communication/phone-call-01')),
  LinePlaceholder: lazy(() => import('./Figma/Line/General/placeholder')),
  LinePlusCircle: lazy(() => import('./Figma/Line/General/plus-circle')),
  LineReceipt: lazy(() => import('./Figma/Line/Finance/receipt')),
  LineRefreshCw05: lazy(() => import('./Figma/Line/Arrows/refresh-cw-05')),
  LineRepeat04: lazy(() => import('./Figma/Line/Media/repeat-04')),
  LineSearchSm: lazy(() => import('./Figma/Line/General/search-sm')),
  LineShare02: lazy(() => import('./Figma/Line/General/share-02')),
  LineShield01: lazy(() => import('./Figma/Line/General/shield-01')),
  LineStar01: lazy(() => import('./Figma/Line/Shapes/star-01')),
  LineTablet01: lazy(() => import('./Figma/Line/Communication/tablet-01')),
  LineThumbsUp: lazy(() => import('./Figma/Line/Alerts/thumbs-up')),
  LineTrash01: lazy(() => import('./Figma/Line/General/trash-01')),
  LineTrash04: lazy(() => import('./Figma/Line/General/trash-04')),
  LineUsersEdit: lazy(() => import('./Figma/Line/General/users-edit')),
  LineUsersPlus: lazy(() => import('./Figma/Line/General/users-plus')),
  LineVolumeMax: lazy(() => import('./Figma/Line/Media/volume-max')),
  LineVolumeX: lazy(() => import('./Figma/Line/Media/volume-x')),
  LogoFacebook: lazy(() => import('./Logo/facebook')),
  LogoInstagram: lazy(() => import('./Logo/instagram')),
  LogoTabtouchCompact: lazy(() => import('./Logo/tabtouch-compact')),
  LogoX: lazy(() => import('./Logo/x')),
  NationalFlagsAfghanistan: lazy(() => import('./NationalFlags/Afghanistan')),
  NationalFlagsAlandIslands: lazy(() => import('./NationalFlags/Aland-Islands')),
  NationalFlagsAlbania: lazy(() => import('./NationalFlags/Albania')),
  NationalFlagsAlgeria: lazy(() => import('./NationalFlags/Algeria')),
  NationalFlagsAndorra: lazy(() => import('./NationalFlags/Andorra')),
  NationalFlagsAngola: lazy(() => import('./NationalFlags/Angola')),
  NationalFlagsAnguilla: lazy(() => import('./NationalFlags/Anguilla')),
  NationalFlagsAntiguaAndBarbuda: lazy(() => import('./NationalFlags/Antigua-and-Barbuda')),
  NationalFlagsArgentina: lazy(() => import('./NationalFlags/Argentina')),
  NationalFlagsArmenia: lazy(() => import('./NationalFlags/Armenia')),
  NationalFlagsAruba: lazy(() => import('./NationalFlags/Aruba')),
  NationalFlagsAustralia: lazy(() => import('./NationalFlags/Australia')),
  NationalFlagsAustria: lazy(() => import('./NationalFlags/Austria')),
  NationalFlagsAzerbaijan: lazy(() => import('./NationalFlags/Azerbaijan')),
  NationalFlagsBahrain: lazy(() => import('./NationalFlags/Bahrain')),
  NationalFlagsBangladesh: lazy(() => import('./NationalFlags/Bangladesh')),
  NationalFlagsBarbados: lazy(() => import('./NationalFlags/Barbados')),
  NationalFlagsBelarus: lazy(() => import('./NationalFlags/Belarus')),
  NationalFlagsBelgium: lazy(() => import('./NationalFlags/Belgium')),
  NationalFlagsBelize: lazy(() => import('./NationalFlags/Belize')),
  NationalFlagsBenin: lazy(() => import('./NationalFlags/Benin')),
  NationalFlagsBermuda: lazy(() => import('./NationalFlags/Bermuda')),
  NationalFlagsBhutan: lazy(() => import('./NationalFlags/Bhutan')),
  NationalFlagsBolivia: lazy(() => import('./NationalFlags/Bolivia')),
  NationalFlagsBosniaAndHerzegovina: lazy(() => import('./NationalFlags/Bosnia-and-Herzegovina')),
  NationalFlagsBotswana: lazy(() => import('./NationalFlags/Botswana')),
  NationalFlagsBrazil: lazy(() => import('./NationalFlags/Brazil')),
  NationalFlagsBritishVirginIslands: lazy(() => import('./NationalFlags/British-Virgin-Islands')),
  NationalFlagsBruneiDarussalam: lazy(() => import('./NationalFlags/Brunei-Darussalam')),
  NationalFlagsBulgaria: lazy(() => import('./NationalFlags/Bulgaria')),
  NationalFlagsBurkinaFaso: lazy(() => import('./NationalFlags/Burkina-Faso')),
  NationalFlagsBurundi: lazy(() => import('./NationalFlags/Burundi')),
  NationalFlagsCAF: lazy(() => import('./NationalFlags/CAF')),
  NationalFlagsCAS: lazy(() => import('./NationalFlags/CAS')),
  NationalFlagsCEU: lazy(() => import('./NationalFlags/CEU')),
  NationalFlagsCOC: lazy(() => import('./NationalFlags/COC')),
  NationalFlagsCSA: lazy(() => import('./NationalFlags/CSA')),
  NationalFlagsCaboVerde: lazy(() => import('./NationalFlags/Cabo-Verde')),
  NationalFlagsCambodia: lazy(() => import('./NationalFlags/Cambodia')),
  NationalFlagsCameroon: lazy(() => import('./NationalFlags/Cameroon')),
  NationalFlagsCanada: lazy(() => import('./NationalFlags/Canada')),
  NationalFlagsCapeVerde: lazy(() => import('./NationalFlags/Cape-Verde')),
  NationalFlagsCaymanIslands: lazy(() => import('./NationalFlags/Cayman-Islands')),
  NationalFlagsCentralAfricanRepublic: lazy(() => import('./NationalFlags/Central-African-Republic')),
  NationalFlagsCentralNorthAmerica: lazy(() => import('./NationalFlags/Central-North-America')),
  NationalFlagsChad: lazy(() => import('./NationalFlags/Chad')),
  NationalFlagsChile: lazy(() => import('./NationalFlags/Chile')),
  NationalFlagsChina: lazy(() => import('./NationalFlags/China')),
  NationalFlagsColombia: lazy(() => import('./NationalFlags/Colombia')),
  NationalFlagsComoros: lazy(() => import('./NationalFlags/Comoros')),
  NationalFlagsCongo: lazy(() => import('./NationalFlags/Congo')),
  NationalFlagsCookIslands: lazy(() => import('./NationalFlags/Cook-Islands')),
  NationalFlagsCostaRica: lazy(() => import('./NationalFlags/Costa-Rica')),
  NationalFlagsCoteDIvoire: lazy(() => import('./NationalFlags/Cote-dIvoire')),
  NationalFlagsCroatia: lazy(() => import('./NationalFlags/Croatia')),
  NationalFlagsCuba: lazy(() => import('./NationalFlags/Cuba')),
  NationalFlagsCyprus: lazy(() => import('./NationalFlags/Cyprus')),
  NationalFlagsCzechRepublic: lazy(() => import('./NationalFlags/Czech-Republic')),
  NationalFlagsDemocraticRepublicOfTheCongo: lazy(() => import('./NationalFlags/Democratic-Republic-of-the-Congo')),
  NationalFlagsDenmark: lazy(() => import('./NationalFlags/Denmark')),
  NationalFlagsDjibouti: lazy(() => import('./NationalFlags/Djibouti')),
  NationalFlagsDominica: lazy(() => import('./NationalFlags/Dominica')),
  NationalFlagsDominicanRepublic: lazy(() => import('./NationalFlags/Dominican-Republic')),
  NationalFlagsEastTimor: lazy(() => import('./NationalFlags/East-Timor')),
  NationalFlagsEcuador: lazy(() => import('./NationalFlags/Ecuador')),
  NationalFlagsEgypt: lazy(() => import('./NationalFlags/Egypt')),
  NationalFlagsElSalvador: lazy(() => import('./NationalFlags/El-Salvador')),
  NationalFlagsEngland: lazy(() => import('./NationalFlags/England')),
  NationalFlagsEquatorialGuinea: lazy(() => import('./NationalFlags/Equatorial-Guinea')),
  NationalFlagsEritrea: lazy(() => import('./NationalFlags/Eritrea')),
  NationalFlagsEstonia: lazy(() => import('./NationalFlags/Estonia')),
  NationalFlagsEswatini: lazy(() => import('./NationalFlags/Eswatini')),
  NationalFlagsEthiopia: lazy(() => import('./NationalFlags/Ethiopia')),
  NationalFlagsEuropeanUnion: lazy(() => import('./NationalFlags/European-Union')),
  NationalFlagsFalklandIslands: lazy(() => import('./NationalFlags/Falkland-Islands')),
  NationalFlagsFaroeIslands: lazy(() => import('./NationalFlags/Faroe-Islands')),
  NationalFlagsFederatedStatesOfMicronesia: lazy(() => import('./NationalFlags/Federated-States-of-Micronesia')),
  NationalFlagsFiji: lazy(() => import('./NationalFlags/Fiji')),
  NationalFlagsFinland: lazy(() => import('./NationalFlags/Finland')),
  NationalFlagsFrance: lazy(() => import('./NationalFlags/France')),
  NationalFlagsFrenchPolynesia: lazy(() => import('./NationalFlags/French-Polynesia')),
  NationalFlagsGabon: lazy(() => import('./NationalFlags/Gabon')),
  NationalFlagsGeorgia: lazy(() => import('./NationalFlags/Georgia')),
  NationalFlagsGermany: lazy(() => import('./NationalFlags/Germany')),
  NationalFlagsGhana: lazy(() => import('./NationalFlags/Ghana')),
  NationalFlagsGibraltar: lazy(() => import('./NationalFlags/Gibraltar')),
  NationalFlagsGreece: lazy(() => import('./NationalFlags/Greece')),
  NationalFlagsGreenland: lazy(() => import('./NationalFlags/Greenland')),
  NationalFlagsGrenada: lazy(() => import('./NationalFlags/Grenada')),
  NationalFlagsGuatemala: lazy(() => import('./NationalFlags/Guatemala')),
  NationalFlagsGuernsey: lazy(() => import('./NationalFlags/Guernsey')),
  NationalFlagsGuinea: lazy(() => import('./NationalFlags/Guinea')),
  NationalFlagsGuineaBissau: lazy(() => import('./NationalFlags/Guinea-Bissau')),
  NationalFlagsGuyana: lazy(() => import('./NationalFlags/Guyana')),
  NationalFlagsHaiti: lazy(() => import('./NationalFlags/Haiti')),
  NationalFlagsHonduras: lazy(() => import('./NationalFlags/Honduras')),
  NationalFlagsHongKong: lazy(() => import('./NationalFlags/Hong-Kong')),
  NationalFlagsHungary: lazy(() => import('./NationalFlags/Hungary')),
  NationalFlagsIceland: lazy(() => import('./NationalFlags/Iceland')),
  NationalFlagsIndia: lazy(() => import('./NationalFlags/India')),
  NationalFlagsIndonesia: lazy(() => import('./NationalFlags/Indonesia')),
  NationalFlagsIran: lazy(() => import('./NationalFlags/Iran')),
  NationalFlagsIraq: lazy(() => import('./NationalFlags/Iraq')),
  NationalFlagsIreland: lazy(() => import('./NationalFlags/Ireland')),
  NationalFlagsIsleOfMan: lazy(() => import('./NationalFlags/Isle-of-Man')),
  NationalFlagsIsrael: lazy(() => import('./NationalFlags/Israel')),
  NationalFlagsItaly: lazy(() => import('./NationalFlags/Italy')),
  NationalFlagsIvoryCoast: lazy(() => import('./NationalFlags/Ivory-Coast')),
  NationalFlagsJamaica: lazy(() => import('./NationalFlags/Jamaica')),
  NationalFlagsJapan: lazy(() => import('./NationalFlags/Japan')),
  NationalFlagsJersey: lazy(() => import('./NationalFlags/Jersey')),
  NationalFlagsJordan: lazy(() => import('./NationalFlags/Jordan')),
  NationalFlagsKM: lazy(() => import('./NationalFlags/KM')),
  NationalFlagsKN: lazy(() => import('./NationalFlags/KN')),
  NationalFlagsKazakhstan: lazy(() => import('./NationalFlags/Kazakhstan')),
  NationalFlagsKenya: lazy(() => import('./NationalFlags/Kenya')),
  NationalFlagsKiribati: lazy(() => import('./NationalFlags/Kiribati')),
  NationalFlagsKosovo: lazy(() => import('./NationalFlags/Kosovo')),
  NationalFlagsKuwait: lazy(() => import('./NationalFlags/Kuwait')),
  NationalFlagsKyrgyzstan: lazy(() => import('./NationalFlags/Kyrgyzstan')),
  NationalFlagsLaos: lazy(() => import('./NationalFlags/Laos')),
  NationalFlagsLatvia: lazy(() => import('./NationalFlags/Latvia')),
  NationalFlagsLebanon: lazy(() => import('./NationalFlags/Lebanon')),
  NationalFlagsLesotho: lazy(() => import('./NationalFlags/Lesotho')),
  NationalFlagsLiberia: lazy(() => import('./NationalFlags/Liberia')),
  NationalFlagsLibya: lazy(() => import('./NationalFlags/Libya')),
  NationalFlagsLiechtenstein: lazy(() => import('./NationalFlags/Liechtenstein')),
  NationalFlagsLithuania: lazy(() => import('./NationalFlags/Lithuania')),
  NationalFlagsLuxembourg: lazy(() => import('./NationalFlags/Luxembourg')),
  NationalFlagsMacao: lazy(() => import('./NationalFlags/Macao')),
  NationalFlagsMadagascar: lazy(() => import('./NationalFlags/Madagascar')),
  NationalFlagsMalawi: lazy(() => import('./NationalFlags/Malawi')),
  NationalFlagsMalaysia: lazy(() => import('./NationalFlags/Malaysia')),
  NationalFlagsMaldives: lazy(() => import('./NationalFlags/Maldives')),
  NationalFlagsMali: lazy(() => import('./NationalFlags/Mali')),
  NationalFlagsMalta: lazy(() => import('./NationalFlags/Malta')),
  NationalFlagsMarshallIslands: lazy(() => import('./NationalFlags/Marshall-Islands')),
  NationalFlagsMauritania: lazy(() => import('./NationalFlags/Mauritania')),
  NationalFlagsMauritius: lazy(() => import('./NationalFlags/Mauritius')),
  NationalFlagsMexico: lazy(() => import('./NationalFlags/Mexico')),
  NationalFlagsMoldova: lazy(() => import('./NationalFlags/Moldova')),
  NationalFlagsMonaco: lazy(() => import('./NationalFlags/Monaco')),
  NationalFlagsMongolia: lazy(() => import('./NationalFlags/Mongolia')),
  NationalFlagsMontenegro: lazy(() => import('./NationalFlags/Montenegro')),
  NationalFlagsMontserrat: lazy(() => import('./NationalFlags/Montserrat')),
  NationalFlagsMorocco: lazy(() => import('./NationalFlags/Morocco')),
  NationalFlagsMozambique: lazy(() => import('./NationalFlags/Mozambique')),
  NationalFlagsMyanmar: lazy(() => import('./NationalFlags/Myanmar')),
  NationalFlagsNamibia: lazy(() => import('./NationalFlags/Namibia')),
  NationalFlagsNauru: lazy(() => import('./NationalFlags/Nauru')),
  NationalFlagsNepal: lazy(() => import('./NationalFlags/Nepal')),
  NationalFlagsNetherlands: lazy(() => import('./NationalFlags/Netherlands')),
  NationalFlagsNewZealand: lazy(() => import('./NationalFlags/New-Zealand')),
  NationalFlagsNicaragua: lazy(() => import('./NationalFlags/Nicaragua')),
  NationalFlagsNiger: lazy(() => import('./NationalFlags/Niger')),
  NationalFlagsNigeria: lazy(() => import('./NationalFlags/Nigeria')),
  NationalFlagsNorthKorea: lazy(() => import('./NationalFlags/North-Korea')),
  NationalFlagsNorthMacedonia: lazy(() => import('./NationalFlags/North-Macedonia')),
  NationalFlagsNorthernIreland: lazy(() => import('./NationalFlags/Northern-Ireland')),
  NationalFlagsNorway: lazy(() => import('./NationalFlags/Norway')),
  NationalFlagsOman: lazy(() => import('./NationalFlags/Oman')),
  NationalFlagsPakistan: lazy(() => import('./NationalFlags/Pakistan')),
  NationalFlagsPalau: lazy(() => import('./NationalFlags/Palau')),
  NationalFlagsPalestine: lazy(() => import('./NationalFlags/Palestine')),
  NationalFlagsPanama: lazy(() => import('./NationalFlags/Panama')),
  NationalFlagsPapuaNewGuinea: lazy(() => import('./NationalFlags/Papua-New-Guinea')),
  NationalFlagsParaguay: lazy(() => import('./NationalFlags/Paraguay')),
  NationalFlagsPeru: lazy(() => import('./NationalFlags/Peru')),
  NationalFlagsPhilippines: lazy(() => import('./NationalFlags/Philippines')),
  NationalFlagsPoland: lazy(() => import('./NationalFlags/Poland')),
  NationalFlagsPortugal: lazy(() => import('./NationalFlags/Portugal')),
  NationalFlagsPuertoRico: lazy(() => import('./NationalFlags/Puerto-Rico')),
  NationalFlagsQatar: lazy(() => import('./NationalFlags/Qatar')),
  NationalFlagsRomania: lazy(() => import('./NationalFlags/Romania')),
  NationalFlagsRussia: lazy(() => import('./NationalFlags/Russia')),
  NationalFlagsRwanda: lazy(() => import('./NationalFlags/Rwanda')),
  NationalFlagsSaintHelena: lazy(() => import('./NationalFlags/Saint-Helena')),
  NationalFlagsSaintKittsAndNevis: lazy(() => import('./NationalFlags/Saint-Kitts-and-Nevis')),
  NationalFlagsSaintLucia: lazy(() => import('./NationalFlags/Saint-Lucia')),
  NationalFlagsSaintVincentAndTheGrenadines: lazy(() => import('./NationalFlags/Saint-Vincent-and-the-Grenadines')),
  NationalFlagsSamoa: lazy(() => import('./NationalFlags/Samoa')),
  NationalFlagsSanMarino: lazy(() => import('./NationalFlags/San-Marino')),
  NationalFlagsSaoTomeAndPrincipe: lazy(() => import('./NationalFlags/Sao-Tome-and-Principe')),
  NationalFlagsSaudiArabia: lazy(() => import('./NationalFlags/Saudi-Arabia')),
  NationalFlagsScotland: lazy(() => import('./NationalFlags/Scotland')),
  NationalFlagsSenegal: lazy(() => import('./NationalFlags/Senegal')),
  NationalFlagsSerbia: lazy(() => import('./NationalFlags/Serbia')),
  NationalFlagsSeychelles: lazy(() => import('./NationalFlags/Seychelles')),
  NationalFlagsSierraLeone: lazy(() => import('./NationalFlags/Sierra-Leone')),
  NationalFlagsSingapore: lazy(() => import('./NationalFlags/Singapore')),
  NationalFlagsSlovakia: lazy(() => import('./NationalFlags/Slovakia')),
  NationalFlagsSlovenia: lazy(() => import('./NationalFlags/Slovenia')),
  NationalFlagsSolomonIslands: lazy(() => import('./NationalFlags/Solomon-Islands')),
  NationalFlagsSomalia: lazy(() => import('./NationalFlags/Somalia')),
  NationalFlagsSouthAfrica: lazy(() => import('./NationalFlags/South-Africa')),
  NationalFlagsSouthKorea: lazy(() => import('./NationalFlags/South-Korea')),
  NationalFlagsSouthSudan: lazy(() => import('./NationalFlags/South-Sudan')),
  NationalFlagsSpain: lazy(() => import('./NationalFlags/Spain')),
  NationalFlagsSriLanka: lazy(() => import('./NationalFlags/Sri-Lanka')),
  NationalFlagsSudan: lazy(() => import('./NationalFlags/Sudan')),
  NationalFlagsSuriname: lazy(() => import('./NationalFlags/Suriname')),
  NationalFlagsSweden: lazy(() => import('./NationalFlags/Sweden')),
  NationalFlagsSwitzerland: lazy(() => import('./NationalFlags/Switzerland')),
  NationalFlagsSyria: lazy(() => import('./NationalFlags/Syria')),
  NationalFlagsTaiwan: lazy(() => import('./NationalFlags/Taiwan')),
  NationalFlagsTajikistan: lazy(() => import('./NationalFlags/Tajikistan')),
  NationalFlagsTanzania: lazy(() => import('./NationalFlags/Tanzania')),
  NationalFlagsThailand: lazy(() => import('./NationalFlags/Thailand')),
  NationalFlagsTheBahamas: lazy(() => import('./NationalFlags/The-Bahamas')),
  NationalFlagsTheGambia: lazy(() => import('./NationalFlags/The-Gambia')),
  NationalFlagsTogo: lazy(() => import('./NationalFlags/Togo')),
  NationalFlagsTokelau: lazy(() => import('./NationalFlags/Tokelau')),
  NationalFlagsTonga: lazy(() => import('./NationalFlags/Tonga')),
  NationalFlagsTrinidadAndTobago: lazy(() => import('./NationalFlags/Trinidad-and-Tobago')),
  NationalFlagsTunisia: lazy(() => import('./NationalFlags/Tunisia')),
  NationalFlagsTurkey: lazy(() => import('./NationalFlags/Turkey')),
  NationalFlagsTurkmenistan: lazy(() => import('./NationalFlags/Turkmenistan')),
  NationalFlagsTurksAndCaicosIslands: lazy(() => import('./NationalFlags/Turks-and-Caicos-Islands')),
  NationalFlagsTuvalu: lazy(() => import('./NationalFlags/Tuvalu')),
  NationalFlagsUSA: lazy(() => import('./NationalFlags/USA')),
  NationalFlagsUSVirginIslands: lazy(() => import('./NationalFlags/US-Virgin-Islands')),
  NationalFlagsUganda: lazy(() => import('./NationalFlags/Uganda')),
  NationalFlagsUkraine: lazy(() => import('./NationalFlags/Ukraine')),
  NationalFlagsUnitedArabEmirates: lazy(() => import('./NationalFlags/United-Arab-Emirates')),
  NationalFlagsUnitedKingdom: lazy(() => import('./NationalFlags/United-Kingdom')),
  NationalFlagsUnitedStates: lazy(() => import('./NationalFlags/United-States')),
  NationalFlagsUruguay: lazy(() => import('./NationalFlags/Uruguay')),
  NationalFlagsUzbekistan: lazy(() => import('./NationalFlags/Uzbekistan')),
  NationalFlagsVanuatu: lazy(() => import('./NationalFlags/Vanuatu')),
  NationalFlagsVaticanCity: lazy(() => import('./NationalFlags/Vatican-City')),
  NationalFlagsVenezuela: lazy(() => import('./NationalFlags/Venezuela')),
  NationalFlagsVietnam: lazy(() => import('./NationalFlags/Vietnam')),
  NationalFlagsWales: lazy(() => import('./NationalFlags/Wales')),
  NationalFlagsWorldwide: lazy(() => import('./NationalFlags/Worldwide')),
  NationalFlagsYemen: lazy(() => import('./NationalFlags/Yemen')),
  NationalFlagsZambia: lazy(() => import('./NationalFlags/Zambia')),
  NationalFlagsZimbabwe: lazy(() => import('./NationalFlags/Zimbabwe')),
  SolidBarChart10: lazy(() => import('./Figma/Solid/Charts/bar-chart-10')),
  SolidBell01: lazy(() => import('./Figma/Solid/Alerts/bell-01')),
  SolidBellRinging01: lazy(() => import('./Figma/Solid/Alerts/bell-ringing-01')),
  SolidCheckCircle: lazy(() => import('./Figma/Solid/General/check-circle')),
  SolidCheckVerified02: lazy(() => import('./Figma/Solid/General/check-verified-02')),
  SolidChevronDown: lazy(() => import('./Figma/Solid/Arrows/chevron-down')),
  SolidChevronLeft: lazy(() => import('./Figma/Solid/Arrows/chevron-left')),
  SolidChevronLeftDouble: lazy(() => import('./Figma/Solid/Arrows/chevron-left-double')),
  SolidChevronRight: lazy(() => import('./Figma/Solid/Arrows/chevron-right')),
  SolidChevronRightDouble: lazy(() => import('./Figma/Solid/Arrows/chevron-right-double')),
  SolidChevronUp: lazy(() => import('./Figma/Solid/Arrows/chevron-up')),
  SolidCircle: lazy(() => import('./Figma/Solid/Shapes/circle')),
  SolidFile06: lazy(() => import('./Figma/Solid/Files/file-06')),
  SolidLayoutGrid01: lazy(() => import('./Figma/Solid/Layout/layout-grid-01')),
  SolidList: lazy(() => import('./Figma/Solid/Layout/list')),
  SolidLock01: lazy(() => import('./Figma/Solid/Security/lock-01')),
  SolidPauseCircle: lazy(() => import('./Figma/Solid/Media/pause-circle')),
  SolidPlayCircle: lazy(() => import('./Figma/Solid/Media/play-circle')),
  SolidRefreshCw01: lazy(() => import('./Figma/Solid/Arrows/refresh-cw-01')),
  SolidRows02: lazy(() => import('./Figma/Solid/Layout/rows-02')),
  SolidScale02: lazy(() => import('./Figma/Solid/Editor/scale-02')),
  SolidSkipBack15: lazy(() => import('./Figma/Solid/Arrows/skip-back-15')),
  SolidSkipForward15: lazy(() => import('./Figma/Solid/Arrows/skip-forward-15')),
  SolidStar01: lazy(() => import('./Figma/Solid/Shapes/star-01')),
  SolidStopCircle: lazy(() => import('./Figma/Solid/Media/stop-circle')),
  SolidTarget03: lazy(() => import('./Figma/Solid/General/target-03')),
  SolidTrendUp01: lazy(() => import('./Figma/Solid/Charts/trend-up-01')),
  SolidTriangle: lazy(() => import('./Figma/Solid/Shapes/triangle')),
  SolidTrophy01: lazy(() => import('./Figma/Solid/Education/trophy-01')),
  SolidUser01: lazy(() => import('./Figma/Solid/Users/user-01')),
  SolidXCircle: lazy(() => import('./Figma/Solid/General/x-circle')),
  SolidXClose: lazy(() => import('./Figma/Solid/General/x-close')),
  SportsAmericanFootball: lazy(() => import('./Sports/american_football')),
  SportsAsianGames: lazy(() => import('./Sports/asian_games')),
  SportsAthletics: lazy(() => import('./Sports/athletics')),
  SportsAustralianRules: lazy(() => import('./Sports/australian_rules')),
  SportsBadminton: lazy(() => import('./Sports/badminton')),
  SportsBandy: lazy(() => import('./Sports/bandy')),
  SportsBaseball: lazy(() => import('./Sports/baseball')),
  SportsBasketball: lazy(() => import('./Sports/basketball')),
  SportsBeachSoccer: lazy(() => import('./Sports/beach_soccer')),
  SportsBeachVolley: lazy(() => import('./Sports/beach_volley')),
  SportsBowling: lazy(() => import('./Sports/bowling')),
  SportsBowls: lazy(() => import('./Sports/bowls')),
  SportsBoxing: lazy(() => import('./Sports/boxing')),
  SportsBrannboll: lazy(() => import('./Sports/brannboll')),
  SportsBridge: lazy(() => import('./Sports/bridge')),
  SportsChess: lazy(() => import('./Sports/chess')),
  SportsCommonwealthGames: lazy(() => import('./Sports/commonwealth_games')),
  SportsCricket: lazy(() => import('./Sports/cricket')),
  SportsCrossSportSpecials: lazy(() => import('./Sports/cross-sport_specials')),
  SportsCurling: lazy(() => import('./Sports/curling')),
  SportsCycling: lazy(() => import('./Sports/cycling')),
  SportsCycloCross: lazy(() => import('./Sports/cyclo-cross')),
  SportsDarts: lazy(() => import('./Sports/darts')),
  SportsDefault: lazy(() => import('./Sports/default')),
  SportsDiscGolf: lazy(() => import('./Sports/disc_golf')),
  SportsDiving: lazy(() => import('./Sports/diving')),
  SportsDroneRacing: lazy(() => import('./Sports/drone_racing')),
  SportsEnhancedAccas: lazy(() => import('./Sports/enhanced_accas')),
  SportsEquestrian: lazy(() => import('./Sports/equestrian')),
  SportsEsports: lazy(() => import('./Sports/esports')),
  SportsEsportsBasketball: lazy(() => import('./Sports/esports_basketball')),
  SportsFieldHockey: lazy(() => import('./Sports/field_hockey')),
  SportsFigureSkating: lazy(() => import('./Sports/figure_skating')),
  SportsFloorball: lazy(() => import('./Sports/floorball')),
  SportsFootball: lazy(() => import('./Sports/football')),
  SportsFormula1: lazy(() => import('./Sports/formula_1')),
  SportsFortuneTeller: lazy(() => import('./Sports/fortune_teller')),
  SportsFutsal: lazy(() => import('./Sports/futsal')),
  SportsGaelicSports: lazy(() => import('./Sports/gaelic_sports')),
  SportsGallops: lazy(() => import('./Sports/gallops')),
  SportsGolf: lazy(() => import('./Sports/golf')),
  SportsGreyhounds: lazy(() => import('./Sports/greyhounds')),
  SportsHandball: lazy(() => import('./Sports/handball')),
  SportsHappyDays: lazy(() => import('./Sports/happy_days')),
  SportsHappyHour: lazy(() => import('./Sports/happy_hour')),
  SportsHorseRacing: lazy(() => import('./Sports/horse_racing')),
  SportsIceHockey: lazy(() => import('./Sports/ice_hockey')),
  SportsIndoorFootball: lazy(() => import('./Sports/indoor_football')),
  SportsIndoorHockey: lazy(() => import('./Sports/indoor_hockey')),
  SportsInlineHockey: lazy(() => import('./Sports/inline_hockey')),
  SportsInternationalRules: lazy(() => import('./Sports/international_rules')),
  SportsIntervalBetting: lazy(() => import('./Sports/interval_betting')),
  SportsLacrosse: lazy(() => import('./Sports/lacrosse')),
  SportsMediterraneanGames: lazy(() => import('./Sports/mediterranean_games')),
  SportsMotorsports: lazy(() => import('./Sports/motorsports')),
  SportsMountainBike: lazy(() => import('./Sports/mountain_bike')),
  SportsNetball: lazy(() => import('./Sports/netball')),
  SportsOlympicGames: lazy(() => import('./Sports/olympic_games')),
  SportsOrienteering: lazy(() => import('./Sports/orienteering')),
  SportsPadel: lazy(() => import('./Sports/padel')),
  SportsPesapallo: lazy(() => import('./Sports/pesapallo')),
  SportsPickleball: lazy(() => import('./Sports/pickleball')),
  SportsPoker: lazy(() => import('./Sports/poker')),
  SportsPolitics: lazy(() => import('./Sports/politics')),
  SportsPool: lazy(() => import('./Sports/pool')),
  SportsRacketlon: lazy(() => import('./Sports/racketlon')),
  SportsRinkHockey: lazy(() => import('./Sports/rink_hockey')),
  SportsRollerHockey: lazy(() => import('./Sports/roller_hockey')),
  SportsRowing: lazy(() => import('./Sports/rowing')),
  SportsRugbyLeague: lazy(() => import('./Sports/rugby_league')),
  SportsRugbyUnion: lazy(() => import('./Sports/rugby_union')),
  SportsSnooker: lazy(() => import('./Sports/snooker')),
  SportsSoftball: lazy(() => import('./Sports/softball')),
  SportsSquash: lazy(() => import('./Sports/squash')),
  SportsSumo: lazy(() => import('./Sports/sumo')),
  SportsSurfing: lazy(() => import('./Sports/surfing')),
  SportsSwimming: lazy(() => import('./Sports/swimming')),
  SportsTableTennis: lazy(() => import('./Sports/table_tennis')),
  SportsTablehockey: lazy(() => import('./Sports/tablehockey')),
  SportsTabtouchExclusivesRwwa: lazy(() => import('./Sports/tabtouch_exclusives__rwwa_')),
  SportsTennis: lazy(() => import('./Sports/tennis')),
  SportsTrotting: lazy(() => import('./Sports/trotting')),
  SportsTvNovelty: lazy(() => import('./Sports/tv___novelty')),
  SportsUfcMma: lazy(() => import('./Sports/ufc_mma')),
  SportsUniversiade: lazy(() => import('./Sports/universiade')),
  SportsVolleyball: lazy(() => import('./Sports/volleyball')),
  SportsWaterPolo: lazy(() => import('./Sports/water_polo')),
  SportsWeightlifting: lazy(() => import('./Sports/weightlifting')),
  SportsWinterOlympicGames: lazy(() => import('./Sports/winter_olympic_games')),
  SportsWinterSports: lazy(() => import('./Sports/winter_sports')),
  SportsWinterXGames: lazy(() => import('./Sports/winter_x-games')),
  SportsWrestling: lazy(() => import('./Sports/wrestling')),
  SportsWweProWrestling: lazy(() => import('./Sports/wwe_pro_wrestling')),
  SportsYachting: lazy(() => import('./Sports/yachting')),
} as const
